import { locales, getLocale, baseLocale } from './runtime';
// @ts-ignore
export const routes = {
  "/category/[...rest]": {
    "sv": "/kategori/[...rest]",
    "en": "/category/[...rest]",
    "es": "/categoria/[...rest]",
    "da": "/kategori/[...rest]",
    "nb": "/kategori/[...rest]",
    "fi": "/kategoria/[...rest]"
  },
  "/product/[...rest]": {
    "sv": "/produkt/[...rest]",
    "en": "/product/[...rest]",
    "es": "/producto/[...rest]",
    "da": "/produkt/[...rest]",
    "nb": "/produkt/[...rest]",
    "fi": "/tuote/[...rest]"
  },
  "/blog/[...rest]": {
    "sv": "/blogg/[...rest]",
    "en": "/blog/[...rest]",
    "es": "/blog/[...rest]",
    "da": "/blog/[...rest]",
    "nb": "/blogg/[...rest]",
    "fi": "/blogi/[...rest]"
  },
  "/blog/category/[...rest]": {
    "sv": "/blogg/kategori/[...rest]",
    "en": "/blog/category/[...rest]",
    "es": "/blog/categoria/[...rest]",
    "da": "/blog/kategori/[...rest]",
    "nb": "/blogg/kategori/[...rest]",
    "fi": "/blogi/kategoria/[...rest]"
  },
  "/checkout/thank-you/[...rest]": {
    "sv": "/kassa/tack/[...rest]",
    "en": "/checkout/thank-you/[...rest]",
    "es": "/pagar/gracias/[...rest]",
    "da": "/kasse/tak/[...rest]",
    "nb": "/kasse/tak/[...rest]",
    "fi": "/kassa/kiitos/[...rest]"
  },
  "/checkout/[...rest]": {
    "sv": "/kassa/[...rest]",
    "en": "/checkout/[...rest]",
    "es": "/pagar/[...rest]",
    "da": "/kasse/[...rest]",
    "nb": "/kasse/[...rest]",
    "fi": "/kassa/[...rest]"
  },
  "/search/[...rest]": {
    "sv": "/sok/[...rest]",
    "en": "/search/[...rest]",
    "es": "/buscar/[...rest]",
    "da": "/sog/[...rest]",
    "nb": "/sok/[...rest]",
    "fi": "/haku/[...rest]"
  },
  "/news": {
    "sv": "/nyheter",
    "en": "/just-in",
    "es": "/novedades",
    "da": "/nyheder",
    "nb": "/nyheter",
    "fi": "/uutuudet"
  },
  "/news/[...rest]": {
    "sv": "/nyheter/[...rest]",
    "en": "/just-in/[...rest]",
    "es": "/novedades/[...rest]",
    "da": "/nyheder/[...rest]",
    "nb": "/nyheter/[...rest]",
    "fi": "/uutuudet/[...rest]"
  },
  "/all-brands": {
    "sv": "/alla-varumarken",
    "en": "/all-brands",
    "es": "/todas-las-marcas",
    "da": "/alle-maerker",
    "nb": "/alle-merker",
    "fi": "/kaikki-merkit"
  },
  "/brand/[...rest]": {
    "sv": "/varumarke/[...rest]",
    "en": "/brand/[...rest]",
    "es": "/marca/[...rest]",
    "da": "/maerke/[...rest]",
    "nb": "/merke/[...rest]",
    "fi": "/merkki/[...rest]"
  },
  "/use-case": {
    "sv": "/anvandningsomrade",
    "en": "/use-case",
    "es": "/caso-de-uso",
    "da": "/anvendelsesomrade",
    "nb": "/bruksomrade",
    "fi": "/kayttotapaus"
  },
  "/user": {
    "sv": "/anvandare",
    "en": "/user",
    "es": "/usuario",
    "da": "/bruger",
    "nb": "/bruker",
    "fi": "/kayttaja"
  },
  "/campaigns": {
    "sv": "/kampanjer",
    "en": "/campaigns",
    "es": "/promociones",
    "da": "/kampagner",
    "nb": "/kampanjer",
    "fi": "/tarjoukset"
  },
  "/campaigns/[...rest]": {
    "sv": "/kampanjer/[...rest]",
    "en": "/campaigns/[...rest]",
    "es": "/promociones/[...rest]",
    "da": "/kampagner/[...rest]",
    "nb": "/kampanjer/[...rest]",
    "fi": "/tarjoukset/[...rest]"
  },
  "/shop-by": {
    "sv": "/shoppa-enligt",
    "en": "/shop-by",
    "es": "/tienda-por",
    "da": "/shoppe-efter",
    "nb": "/shoppe-etter",
    "fi": "/osta-valinnan-mukaan"
  },
  "/track-order": {
    "sv": "/spara-order",
    "en": "/track-order",
    "es": "/seguimiento-de-pedido",
    "da": "/spor-ordre",
    "nb": "/spor-ordre",
    "fi": "/seuraa-tilausta"
  },
  "/track-order/[...rest]": {
    "sv": "/spara-order/[...rest]",
    "en": "/track-order/[...rest]",
    "es": "/seguimiento-de-pedido/[...rest]",
    "da": "/spor-ordre/[...rest]",
    "nb": "/spor-ordre/[...rest]",
    "fi": "/seuraa-tilausta/[...rest]"
  }
};
// Create lookup tables for faster access
/** @type {Record<string, Record<string, string>>} */
const rawToLocalizedMap = {};
/** @type {Record<string, Record<string, string>>} */
const localizedToRawMap = {};
/** @type {Record<string, RegExp>} */
const patternMap = {};
// TODO: generate this map in the compiler rather then during runtime for more efficiency
// Initialize the lookup tables
const initializeMaps = () => {
    // Process each raw route pattern
    Object.entries(routes).forEach(([rawPattern, localizations]) => {
        // Store raw to localized mapping
        rawToLocalizedMap[rawPattern] = localizations;
        // Create regex pattern for this raw route
        if (rawPattern.includes('[...rest]')) {
            patternMap[rawPattern] = new RegExp(`^${rawPattern.replace(/\/?\[\.\.\.rest\]/g, '(?:/(.*))?')}$`);
        }
        else {
            patternMap[rawPattern] = new RegExp(`^${rawPattern.replace(/\/$/, '')}\\/?$`);
        }
        // Store localized to raw mapping
        Object.entries(localizations).forEach(([locale, localizedPattern]) => {
            if (!localizedToRawMap[locale]) {
                localizedToRawMap[locale] = {};
            }
            localizedToRawMap[locale][localizedPattern] = rawPattern;
        });
    });
};
initializeMaps(); // Initialize on module load
/**
 * Normalizes a URL by removing duplicate slashes
 * @param {URL} url - The URL to normalize
 * @returns {URL} The normalized URL
 */
const normalizeUrl = (url) => {
    url.pathname = normalizePathname(url.pathname);
    return url;
};
/**
 * Normalizes a pathname by removing duplicate slashes
 * @param {string} pathname - The pathname to normalize
 * @returns {string} The normalized pathname
 */
const normalizePathname = (pathname) => {
    return pathname.replace(/\/+/g, '/');
};
/**
 * Get the locale from a URL
 * @param {URL} url - The URL to get the locale from
 * @returns {{ locale: string, flattenedUrl: URL }} The locale and the flattenedUrl URL
 */
export const getLocaleAndFlattenedUrl = (url) => {
    const [locale, ...rest] = url.pathname.split('/').slice(1);
    const flattenedUrl = new URL(url);
    if (locales.includes(locale)) {
        flattenedUrl.pathname = rest.join('/');
    }
    return {
        locale: locales.includes(locale) ? locale : baseLocale,
        flattenedUrl: flattenedUrl
    };
};
/**
 * Localizes a URL path based on the specified locale
 * @param {string} href - The URL to localize
 * @param {string} locale - The locale to localize the URL to
 * @returns {string} The localized URL
 */
export const localizeUrl = (href, locale = getLocale()) => {
    try {
        const newUrl = normalizeUrl(new URL(href));
        // Find matching raw pattern
        for (const [rawPattern, regex] of Object.entries(patternMap)) {
            const match = newUrl.pathname.match(regex);
            if (match) {
                const restParam = match[1] || '';
                const localizationPatterns = rawToLocalizedMap[rawPattern];
                if (localizationPatterns && localizationPatterns[locale]) {
                    const localizedPattern = localizationPatterns[locale];
                    const localizedPath = localizedPattern.replace('[...rest]', restParam);
                    // Set localized path
                    newUrl.pathname = localizedPath;
                    break; // Continue below and add locale path
                }
            }
        }
        // Add the locale path if it's not the base locale
        newUrl.pathname = (locale === baseLocale ? newUrl.pathname : `/${locale}${newUrl.pathname}`).replace(/\/$/, '');
        return newUrl.toString();
    }
    catch (error) {
        // If the URL is invalid, assume it's a path and return as is
        console.error('Error localizing URL:', error);
        return href;
    }
};
/**
 * Converts a localized URL back to its raw (default) version
 * @param {string} href - The URL to localize
 * @returns {string} The localized URL
 */
export const delocalizeUrl = (href) => {
    try {
        // Get a flattenedUrl URL without locale path
        const { flattenedUrl, locale } = getLocaleAndFlattenedUrl(normalizeUrl(new URL(href)));
        const localizedToRawPattern = localizedToRawMap[locale];
        if (localizedToRawPattern) {
            // Try to find an exact match first
            for (const [localizedPattern, rawPattern] of Object.entries(localizedToRawPattern)) {
                // Create regex for the localized pattern
                let localizedRegex;
                if (localizedPattern.includes('[...rest]')) {
                    localizedRegex = new RegExp(`^${localizedPattern.replace(/\[\.\.\.rest\]/g, '?(.*)')}$`);
                }
                else {
                    localizedRegex = new RegExp(`^${localizedPattern.replace(/\/$/, '')}\\/?$`);
                }
                const match = flattenedUrl.pathname.match(localizedRegex);
                if (match) {
                    const restParam = match[1] || '';
                    const rawPath = rawPattern.replace('[...rest]', restParam);
                    // Set raw path
                    flattenedUrl.pathname = rawPath;
                    return flattenedUrl.toString();
                }
            }
        }
        // Return flattenedUrl URL
        return flattenedUrl.toString();
    }
    catch (error) {
        // If the URL is invalid, assume it's a path and return as is
        console.error('Error delocalizing URL:', error);
        return normalizePathname(href);
    }
};
